import { type ClientImgixParams, withByosImgixServerSign } from '@air/component-imgix-image';

const DEFAULT_IMGIX_QUALITY = 50;

type ImageLoaderProps = {
  src: string;
  width?: number;
  height?: number;
  quality?: number;
};

export const imgixLoader = ({ src, width, height, quality }: ImageLoaderProps): string => {
  const params: ClientImgixParams = {
    auto: 'format',
    fit: 'max',
    q: quality || DEFAULT_IMGIX_QUALITY,
    ...(width ? { w: width } : {}),
    ...(height ? { h: height } : {}),
  };

  const signed = withByosImgixServerSign(src, params);

  if (signed !== src) {
    return signed;
  }

  const url = new URL(src);
  const searchParams = url.searchParams;

  if (searchParams.has('s')) {
    return src;
  }
  searchParams.set('auto', searchParams.get('auto') || 'format');
  searchParams.set('fit', searchParams.get('fit') || 'max');
  if (width) {
    searchParams.set('w', width.toString());
  }
  if (height) {
    searchParams.set('h', height.toString());
  }
  searchParams.set('q', (quality || DEFAULT_IMGIX_QUALITY).toString());
  return url.href;
};
